import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 42,
    seconds: 18
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <Section bg="white" data-id="element-488">
      <div className="max-w-4xl mx-auto" data-id="element-489">
        <div className="glass-card rounded-[2.5rem] p-10 md:p-16 text-center border-gold/20" data-id="element-490">
          <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-491">
            Lanzamiento Limitado
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-492">
            ¿Por qué este precio solo hoy?
          </h2>

          <p className="text-charcoal-light font-light mb-12 max-w-2xl mx-auto" data-id="element-493">
            Solo ofrecemos 500 copias a $17.990 para garantizar soporte de
            calidad y construir casos de éxito reales. Después de las primeras
            500 ventas, el precio sube a $39.990 y los bonuses se venden por
            separado.
          </p>

          <div className="max-w-md mx-auto mb-6 md:mb-12" data-id="element-494">
            <div className="flex justify-between text-xs uppercase tracking-widest font-medium mb-3 text-charcoal/60" data-id="element-495">
              <span data-id="element-496">Vendidas: 347</span>
              <span className="text-olive" data-id="element-497">Quedan: 153</span>
            </div>
            <div className="h-2 bg-cream-dark rounded-full overflow-hidden" data-id="element-498">
              <div className="h-full bg-gold rounded-full" style={{
              width: `${347 / 500 * 100}%`
            }} data-id="element-499" />
            </div>
          </div>

          <div className="flex justify-center gap-6" data-id="element-500">
            <div className="text-center" data-id="element-501">
              <p className="text-3xl font-serif text-charcoal" data-id="element-502">
                {formatNumber(timeLeft.hours)}
              </p>
              <p className="text-[10px] uppercase tracking-widest text-charcoal/40 mt-1" data-id="element-503">
                Horas
              </p>
            </div>
            <div className="text-3xl font-serif text-gold/30" data-id="element-504">:</div>
            <div className="text-center" data-id="element-505">
              <p className="text-3xl font-serif text-charcoal" data-id="element-506">
                {formatNumber(timeLeft.minutes)}
              </p>
              <p className="text-[10px] uppercase tracking-widest text-charcoal/40 mt-1" data-id="element-507">
                Min
              </p>
            </div>
            <div className="text-3xl font-serif text-gold/30" data-id="element-508">:</div>
            <div className="text-center" data-id="element-509">
              <p className="text-3xl font-serif text-charcoal" data-id="element-510">
                {formatNumber(timeLeft.seconds)}
              </p>
              <p className="text-[10px] uppercase tracking-widest text-charcoal/40 mt-1" data-id="element-511">
                Seg
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}